import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import logoImg from '../../assets/logo.jpg';
import collegeImg from '../../assets/college.jpg';
import ourstoryImg from '../../assets/ourstory.JPG';

const AboutPreview = () => {
  const highlights = [
    'Cambridge and Nigerian curriculum integration',
    'Small class sizes for personalized attention',
    'State-of-the-art learning facilities',
    'Holistic development approach',
  ];

  return (
    <section className="section-padding bg-white lg:pt-40" style={{ position: 'relative', zIndex: 1 }}>
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          {/* Image Grid */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative order-2 lg:order-1"
          >
            <div className="grid grid-cols-2 gap-3 md:gap-4">
              <div className="space-y-3 md:space-y-4">
                <img
                  src="https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=400&h=300&fit=crop"
                  alt="Students in classroom"
                  className="w-full h-32 md:h-48 object-cover rounded-xl md:rounded-2xl shadow-soft"
                />
                <img
                  src={logoImg}
                  alt="Stirret Schools Logo"
                  className="w-full h-40 md:h-64 object-cover rounded-xl md:rounded-2xl shadow-soft"
                />
              </div>
              <div className="space-y-3 md:space-y-4 pt-6 md:pt-8">
                <img
                  src={collegeImg}
                  alt="Stirret College"
                  className="w-full h-40 md:h-64 object-cover rounded-xl md:rounded-2xl shadow-soft"
                />
                <img
                  src={ourstoryImg}
                  alt="Our Story"
                  className="w-full h-32 md:h-48 object-cover rounded-xl md:rounded-2xl shadow-soft"
                />
              </div>
            </div>
            {/* Experience Badge */}
            <div className="absolute -bottom-6 -right-6 bg-primary-600 text-white p-6 rounded-2xl shadow-hard hidden md:block">
              <div className="text-4xl font-bold">9+</div>
              <div className="text-sm text-primary-200">Years of Excellence</div>
            </div>
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="order-1 lg:order-2"
          >
            <span className="inline-block px-3 py-1 bg-primary-100 text-primary-600 rounded-full text-xs md:text-sm font-medium mb-4">
              About Stirret Schools
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-display font-bold text-gray-900 mb-4 md:mb-6">
              Raising Exceptional Leaders Since 2017
            </h2>
            <p className="text-base md:text-lg text-gray-600 mb-4 md:mb-6 leading-relaxed">
              At Stirret Schools, we believe every child has unique potential waiting to be discovered.
              Our comprehensive educational approach combines academic excellence with character
              development, preparing students to become tomorrow's leaders.
            </p>
            <p className="text-sm md:text-base text-gray-600 mb-6 md:mb-8 leading-relaxed hidden md:block">
              From our Montessori foundation through to our college-preparatory programs, we
              provide a nurturing environment where students thrive academically, socially,
              and emotionally.
            </p>

            {/* Highlights */}
            <ul className="space-y-2 md:space-y-3 mb-6 md:mb-8">
              {highlights.map((item, index) => (
                <li key={index} className="flex items-center gap-2 md:gap-3 text-sm md:text-base text-gray-700">
                  <CheckCircle2 className="text-primary-600 flex-shrink-0" size={18} />
                  {item}
                </li>
              ))}
            </ul>

            <Link to="/about" className="btn-primary group inline-flex text-sm md:text-base">
              Learn More About Us
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={18} />
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutPreview;
